import type { Props } from "react-infinite-scroll-component";

import React, { useLayoutEffect, useRef } from "react";

import LibraryInfiniteScroll from "react-infinite-scroll-component";

// NOTE (Ben, 2025-01-07): Wrapper around react-infinite-scroll-component that adds
// auto-fetching when content doesn't fill the container. The library only triggers
// loading via scroll events, so if initial content doesn't cause overflow (no scrollbar),
// loading never triggers.
const InfiniteScroll: React.FC<Props> = (props) => {
  const { scrollableTarget, hasMore, next, dataLength, ...rest } = props;
  const isAutoFetchingRef = useRef(false);
  const lastDataLengthRef = useRef(dataLength);

  if (dataLength !== lastDataLengthRef.current) {
    isAutoFetchingRef.current = false;
    lastDataLengthRef.current = dataLength;
  }

  // layout effect to auto-fetch if content doesn't fill the container
  // biome-ignore lint/correctness/useExhaustiveDependencies: dataLength is intentionally included to re-check container overflow when new data arrives
  useLayoutEffect(() => {
    if (!scrollableTarget || !hasMore || isAutoFetchingRef.current) {
      return;
    }

    const targetId =
      typeof scrollableTarget === "string" ? scrollableTarget : null;
    if (!targetId) {
      return;
    }

    const container = document.getElementById(targetId);
    if (!container) {
      return;
    }

    if (container.scrollHeight <= container.clientHeight) {
      isAutoFetchingRef.current = true;
      next();
    }
  }, [scrollableTarget, hasMore, next, dataLength]);

  return (
    <LibraryInfiniteScroll
      scrollableTarget={scrollableTarget}
      hasMore={hasMore}
      next={next}
      dataLength={dataLength}
      {...rest}
    />
  );
};

export default InfiniteScroll;
